import ErrorResultPluginSetup from "./error/PluginSetup.js"; // import SuccessResultPluginSetup from './success/PluginSetup'
export default {
  install(molten) {
    ErrorResultPluginSetup.install(molten);
    // SuccessResultPluginSetup.install( molten )
  }
};